// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__TTxxN","header":"PatientBlock_header__3g5KE","label":"PatientBlock_label__1MKJ_","option":"PatientBlock_option__1rCaA"};